import PatientsReassignment from './PatientsReassignment';

export default PatientsReassignment;
